<template>
  <div>
    <v-btn
      color="amber"
      small
      :disabled="ids.length === 0"
      class="mt-2 white--text"
      @click="requestClientCompletionDialog = true"
    >
      一括クライアント校了依頼
    </v-btn>
    <v-simple-table v-if="orderI18ns">
      <thead>
        <tr>
          <th v-if="orders.length">
            <input
              v-model="isAllSelected"
              type="checkbox"
              @click="selectAllIds"
            />
          </th>
          <th v-else></th>
          <th class="text-left">ステータス</th>
          <th class="text-left">発注ID</th>
          <th class="text-left">ロット名</th>
          <th class="text-left">記事種別</th>
          <th class="text-left">記事タイトル</th>
          <th class="text-left">ライター名</th>
          <th class="text-left">販売単価（税抜）</th>
          <th class="text-left">費用総計（税込）</th>
          <th class="text-left">クライアント校了日</th>
          <th class="text-left">クライアント校了期限</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in orders" :key="order.id">
          <td>
            <input
              v-if="isStatus(order, ['completed'])"
              v-model="ids"
              type="checkbox"
              :value="order.id"
            />
          </td>
          <td>
            <v-chip
              class="ma-2 font-weight-bold"
              :color="orderStatusColors[order.status]"
              x-small
              :outlined="isStatus(order, ['completed', 'under_client_inspection'])"
            >
              {{ orderI18ns.status[order.status] }}
            </v-chip>
          </td>
          <td>
            {{ order.id }}
          </td>
          <td>
            {{ order.lotName }}
          </td>
          <td>
            {{ order.postClassification }}
          </td>
          <td>
            <a
              v-if="order.post"
              :href="postEditorUrl(order.post)"
              target="_blank"
            >
              {{ order.post.title }}
            </a>
            <span v-else class="font-weight-light font-italic"
              >記事削除済み</span
            >
          </td>
          <td v-if="order.user">{{ order.user.name }}</td>
          <td v-else></td>
          <td>
            {{ order.salesPrice | jpyPriceNotation }}
          </td>
          <td>
            {{ order.paymentAmountForWriter | jpyPriceNotation }}
          </td>
          <td class="text-center">
            <span v-if="isStatus(order, ['client_completed'])">
              {{ order.clientCompletedOn | momentDate }}
              <v-btn
                color="red"
                class="white--text"
                x-small
                outlined
                @click="editClientCompletedOn(order)"
                >校了日修正</v-btn
              >
            </span>

            <span v-else-if="isStatus(order, ['completed'])">
            </span>
            <span v-else>
              <v-tooltip top>
                <template v-slot:activator="{ on, attr }">
                  <v-icon
                    color="red"
                    class="mt-2"
                    v-bind="attr"
                    small
                    v-on="on"
                  >
                    mdi-alert-circle-outline
                  </v-icon>
                </template>
                <span>ライター校了が完了していない、またはクライアント検収中です</span>
              </v-tooltip>
            </span>
          </td>
          <td class="text-center">
            <span v-if="isStatus(order, ['under_client_inspection'])">
              {{ order.clientCompletionDeadline | momentDate }}
            </span>
            <span v-else-if="isStatus(order, ['completed'])">
              <v-btn
                color="amber"
                class="mt-2 white--text"
                small
                @click="openRequestClientCompletionDialog(order.id)"
              >
                クライアント校了依頼
              </v-btn>
            </span>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-dialog v-model="editDialog" width="500">
      <v-card>
        <v-card-title> クライアント校了日修正 </v-card-title>
        <v-card-text>
          <v-menu
            ref="menuClientCompletedOn"
            v-model="menuClientCompletedOn"
            :close-on-content-click="false"
            :return-value.sync="editableOrder.clientCompletedOn"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="editableOrder.clientCompletedOn"
                label="クライアント校了日"
                prepend-icon="mdi-calendar"
                required
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="editableOrder.clientCompletedOn"
              no-title
              locale="jp-ja"
              :day-format="(date) => new Date(date).getDate()"
              style="height: 300px;"
              @change="
                $refs.menuClientCompletedOn.save(
                  editableOrder.clientCompletedOn
                )
              "
            />
          </v-menu>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn color="error" @click="updateClientCompletedOn"
            >クライアント校了日を修正する</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="requestClientCompletionDialog" width="500">
      <v-card>
        <v-card-title> クライアント校了依頼締切日を指定して下さい </v-card-title>
        <v-card-text>
          <v-menu
            ref="selectBulkRequestClientCompletionDeadline"
            v-model="selectBulkRequestClientCompletionDeadline"
            :close-on-content-click="false"
            :return-value.sync="bulkRequestClientCompletionDeadline"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="bulkRequestClientCompletionDeadline"
                label="クライアント校了依頼締切日"
                prepend-icon="mdi-calendar"
                required
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="bulkRequestClientCompletionDeadline"
              no-title
              locale="jp-ja"
              :day-format="(date) => new Date(date).getDate()"
              style="height: 300px;"
              @change="
                $refs.selectBulkRequestClientCompletionDeadline.save(bulkRequestClientCompletionDeadline)
              "
            />
          </v-menu>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn
            color="primary"
            outlined
            @click="cancelClientCompletion"
            >キャンセル</v-btn
          >
          <v-btn
            color="success"
            @click="requestClientCompletion(ids, bulkRequestClientCompletionDeadline)"
            >上記の日付にてクライアント校了依頼する</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import format_utils from '@/mixins/format_utils'
import snakecaseKeys from 'snakecase-keys'

export default {
  mixins: [format_utils],
  props: {
    orders: {
      type: Array,
      required: true
    },
    site: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data: () => {
    return {
      orderStatusColors: {
        not_applied: '',
        writing: 'primary',
        under_inspection: 'warning',
        completed: 'success',
        under_client_inspection: 'amber',
        client_completed: 'success'
      },
      ids: [],
      editDialog: false,
      requestClientCompletionDialog: false,
      editableOrder: {},
      menuClientCompletedOn: false,
      isAllSelected: false,
      bulkRequestClientCompletionDeadline: null,
      selectBulkRequestClientCompletionDeadline: false
    }
  },
  computed: {
    ...mapState({
      orderI18ns: (state) => snakecaseKeys(state.I18n.enums.order)
    })
  },
  methods: {
    requestClientCompletion (orderIds, clientCompletionDeadline) {
      this.requestClientCompletionDialog = false
      if (
        confirm(
          `${orderIds.length}件のクライアント校了依頼を${
            clientCompletionDeadline || '本日'
          }付けで行います。本当によろしいですか？`
        )
      ) {
        this.$emit('request-client-completion', orderIds, clientCompletionDeadline)
        this.ids = []
      }
    },
    cancelClientCompletion () {
      this.ids = []
      this.requestClientCompletionDialog = false
    },
    postEditorUrl (post) {
      return this.selectedSiteUrlOrigin() + '/admin/posts/' + post.id + '/edit'
    },
    selectedSiteUrlOrigin () {
      if (!this.site || !this.site.id) {
        return ''
      }

      return this.site.initialDomainWithProtocol
    },
    editClientCompletedOn (order) {
      this.editDialog = true
      this.editableOrder = { ...order }
    },
    updateClientCompletedOn () {
      if (confirm('本当にクライアント校了日を修正しますか？')) {
        this.$emit('update-client-completed-on', this.editableOrder)
        this.editableOrder = {}
      }
      this.editDialog = false
    },
    isStatus (order, statuses) {
      return statuses.includes(order.status)
    },
    selectAllIds () {
      if (this.isAllSelected) {
        this.ids = []
        this.isAllSelected = false
      } else {
        this.ids = []
        for (let order in this.orders) {
          if (this.isStatus(this.orders[order], ['completed'])) {
            this.ids.push(this.orders[order].id)
          }
        }
        this.isAllSelected = true
      }
    },
    openRequestClientCompletionDialog (id) {
      this.ids = []
      this.ids.push(id)
      this.requestClientCompletionDialog = true
    }
  }
}
</script>

<style scoped lang="sass">
th, td
  vertical-align: middle
</style>

<style lang="sass">
.v-picker table:not([cellpadding]) th, .v-picker table:not([cellpadding]) td
  padding: 0.1rem
</style>
